// Sugalarm — /api/live-activity wrappers (cycle 168).
//
// Token registration for the iOS Glucose Live Activity (Lock Screen /
// Dynamic Island / CarPlay Dashboard tile). iOS-shell-only callers
// (web/src/lib/liveActivity.ts); JWT-auth'd server-side.

import { request } from "../lib/apiClient";
import type { ApiResult } from "../lib/types";

export type LiveActivityTokenKind = "start" | "update";

export interface LiveActivityTokenBody {
  member_id: string;
  kind: LiveActivityTokenKind;
  token: string;
  bundle_id: string;
}

export function registerLiveActivityToken(
  body: LiveActivityTokenBody,
): Promise<ApiResult<{ ok: boolean }>> {
  return request<{ ok: boolean }>("/api/live-activity/tokens", {
    method: "POST",
    body,
  });
}

export function deleteLiveActivityToken(
  body: Omit<LiveActivityTokenBody, "bundle_id">,
): Promise<ApiResult<{ ok: boolean }>> {
  return request<{ ok: boolean }>("/api/live-activity/tokens", {
    method: "DELETE",
    body,
  });
}
